import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {User} from '../models/user.model';
import {BehaviorSubject, EMPTY, forkJoin, from, Observable, of, throwError} from 'rxjs';
import { catchError, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiRoot: string = environment.crmTest;
  private lastResponse = new BehaviorSubject<string | null>(null);  // BehaviorSubject pour stocker et émettre les changements

  relod:number=0;
  apiA:string = environment.crmTest + '/user';
  api:string =  environment.crmTest + '/users?page=0&group=1';

  constructor(private http: HttpClient) { }

  createUser(u:User){
    return this.http.post(this.apiA,u);
  }

  updateUser(u:User){
    return this.http.post(this.apiA,u);
  }

  // fetchByName(name:string):Observable<any>{
  //   let reusults =this.http.get( environment.crmTest + '/users?page=0&name='+name+'&group='+JSON.parse(localStorage.getItem('userDetails')).group.groupId) 
  //   return reusults ;
  //   // return this.http.get(this.api);
  // }



  
  fetchByName(name: string): Observable<any> {
    if (!name.trim()) return of({ content: [] });
  
    const baseUrl = environment.crmTest + '/users?page=0&name=' + name;
  
    // On crée les 3 requêtes
    const group1 = this.http.get(`${baseUrl}&group=1`);
    const group2 = this.http.get(`${baseUrl}&group=2`);
    const group3 = this.http.get(`${baseUrl}&group=3`);
  
    return forkJoin([group1, group2, group3]).pipe(
      map((responses: any[]) => {
        // On fusionne les tableaux 'content' de chaque réponse
        const allUsers = responses.reduce((acc, current) => {
          return acc.concat(current.content || []);
        }, []);
  
        // Optionnel : Supprimer les doublons si un utilisateur est dans plusieurs groupes
        const uniqueUsers = allUsers.filter((user, index, self) =>
          index === self.findIndex((u) => u.id === user.id)
        );
  
        return { content: uniqueUsers };
      }),
      catchError(err => {
        console.error('Search error', err);
        return of({ content: [] });
      })
    );
  }

  findByRole(role:string):Observable<any>{
    let reusults =this.http.get(this.api) 
    return reusults ;
    // return this.http.get(this.api);
  }

  deleteUser(u:User){
    return this.http.delete(this.api+'/'+u.userId);
  }

  getAllRoles(){
    return this.http.get(environment.api+'/roles');
  }
  // Observable
  getUserByCode<T>(code: string): Observable<T>{
    let url = `${this.apiRoot}/user?code=${code}`;
    console.log("url",url)
    return this.http.get<T>(url);
  }
/*
  getDateClosed(): Observable<string> {
    let url = 'https://crmapi.valeriahotels.com/api/closing/date?';
    return this.http.get(url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId, { responseType: 'text' }).pipe(
      map((response: ArrayBuffer | string) => {
        if (typeof response === 'string') {
          return response;
        } else {
          // Convert ArrayBuffer to string
          return new TextDecoder().decode(response);
        }
      }),
      catchError(error => {
        const errorMessage = 'Error fetching date closed';
        console.error(errorMessage, error);
        return throwError(errorMessage);
      })
    );
  }
*/




  getDateClosed(): Observable<string> {
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || 'null');
    if (!userDetails || !userDetails.group) {
      return EMPTY;
    }
    const url = this.apiRoot + '/closing/date?';
    return this.http.get(url + '&group=' + userDetails.group.groupId, { responseType: 'text' }).pipe(
      map((response: ArrayBuffer | string) => {
        if (typeof response === 'string') {
          this.lastResponse.next(response);
          return response;
        } else {
          const decodedResponse = new TextDecoder().decode(response);
          return decodedResponse;
        }
      }),
      catchError(error => {
        const errorMessage = 'Error fetching date closed';
        console.error(errorMessage, error);
        return throwError(errorMessage);
      })
    );
  }

  // Méthode pour accéder à la dernière réponse stockée
  getLastResponse(): string | null {
    return this.lastResponse;
  }

  addRfidToUser(userId: number, rfid: string): Observable<User> {
    return this.http.get<User>(`${this.apiRoot}/user/${userId}/rfid/add/${rfid}`);
  }

  updateUserCreditLimit(userId: number, creditLimit: number): Observable<User> {
    return this.http.post<User>(`${this.apiRoot}/user/${userId}/creditLimit/${creditLimit}`, {});
  }

  initCreditBalance(userId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiRoot}/user/${userId}/creditBalance/int`, {});
  }


  getTickets(title:any,statusId:any,actiontype:any,roleid:any,userid:any,startaction:any,closeaction:any){

    let url = `${this.apiRoot}/tickets/search?size=200`;
    if (title != "") {
      url = url + `title=${title}`;
    }
    if (statusId != "") {
      url = url + `&statusId=${statusId}`;
    }
    if (actiontype != "") {
      url = url + `&actiontype=${actiontype}`;
    }
    if (roleid != "") {
      url = url + `&roleid=${roleid}`;
    }
    if (userid != "") {
      url = url + `&userid=${userid}`;
    }
    if (startaction != "") {
      url = url + `&startaction=${startaction}`;
    }
    if (closeaction != "") {
      url = url + `&closeaction=${closeaction}`;
    }
    return this.http.get<any>(url);
  }
  addTicket(ticket :any):Observable<any>{
    return  this.http.post(`${this.apiRoot}/tickets/update`,ticket)
  }
  getTicket(id:any){
    const url = `${this.apiRoot}/tickets/${id}`;
    return this.http.get<any>(url);
  }
  getTicketTypes(){
    const url = `${this.apiRoot}/ticket-types`;
    return this.http.get<any>(url);
  }

  getAllUsersByGroup():Observable<any>{
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || 'null');
    if (!userDetails || !userDetails.group) { return EMPTY; }
    let url = `${this.apiRoot}/allusers?group=${userDetails.group.groupId}`;
    console.log("url",url)
    return this.http.get<any>(url);
  }

  deactivateUser(userId: number | string): Observable<any> {
    return this.http.post(`${this.apiRoot}/user/${userId}/deactivate`, {});
  }
  //https://crmapi.valeriahotels.com/api/user/123/deactivate   
  /**
   * Activer un utilisateur (Base locale + Keycloak)
   * @param userId ID de l'utilisateur à activer
   */
  activateUser(userId: number | string): Observable<any> {
    return this.http.post(`${this.apiRoot}/user/${userId}/activate`, {});
  }

  changePassword(userId: number | string, newPassword: string): Observable<any> {
    return this.http.post(`${this.apiRoot}/user/${userId}/change-password`, { newPassword });
  }
}
